import React from 'react';
import { MapPin } from 'lucide-react';
import { US_STATES } from '../data/content';
import './StateTicker.css';

export default function StateTicker() {
  const items = [...US_STATES, ...US_STATES];

  return (
    <div className="ticker-wrap">
      <div className="ticker-inner">
        {items.map((state, i) => (
          <span key={i} className="tick-item">
            <MapPin size={12} strokeWidth={2} style={{ flexShrink: 0 }} />
            {state}
          </span>
        ))}
      </div>
    </div>
  );
}
